import { io, type Socket } from "socket.io-client";

export function connectSocket(): Socket {
  return io({
    path: "/socket.io",
    withCredentials: true,
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 700,
    reconnectionDelayMax: 10_000,
    timeout: 10_000,
  });
}
